import URL from './url';

const config = {
  headers: {
    'Content-Type': 'application/json'
  }
};

export const getServicios = async () => {
  try {
    const res = await URL.get(`/api/servicios`);
    return res.data;
  } catch (err) {
    console.log("Error en action Estados", err);
  }
}

export const getServicioArrayId = async info => {
  try {
    const res = await URL.post(`/api/servicios/arrayIds`, { info });
    return res.data;
  } catch (error) {
    console.error("Error en getServicioArrayId", error)
  }
}